<template>
  <div class="ma-0 pa-0" style="height: 90vh; overflow: hidden">
    <Navigation />
    <v-row class="d-flex justify-end pa-0 ma-0">
      <v-col style="max-width: calc(100% - 56px)">
        <div class="pb-0 mb-0">
          <ToolbarTitles :title="title" class="d-flex flex-wrap mx-auto" />
        </div>
        <div
          class="d-flex flex-wrap justify-space-between my-auto pb-0 mx-auto"
        >
          <data-employed />
          <nav-buttons :title="title" />
        </div>
        <div class="container">
          <TableWithSearch
            :items="getEmployedTags"
            :headers="allHeaders"
            :openDialog="openDialog"
            :showPagination="false"
            @headersUpdated="updateHeaders"
            @refreshItems="refreshItems"
            :showRefresh="true"
            :showEdit="false"
            :showAdd="false"
            :asegurable="'accion:modificaretiquetasempleado'"
          />
        </div>
      </v-col>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    </v-row>
  </div>
</template>

<script>
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Navigation from "./Navigation.vue";
import ToolbarTitles from "../../../Complement/ToolbarTitles.vue";
import DeleteDialog from "../../../Complement/DeleteDialog.vue";
import NavButtons from "../../commons/NavButtons.vue";
import DataEmployed from "../../commons/DataEmployed.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Snackbar from "../../../Complement/Snackbar.vue";
export default {
  components: {
    DataEmployed,
    Navigation,
    ToolbarTitles,
    DeleteDialog,
    NavButtons,
    TableWithSearch,
    Snackbar,
  },
  data() {
    return {
      title: "Etiquetas",
      deleteTitle: "¿Desea eliminar la etiqueta?",
      addModel: " Etiqueta",
      headers: [
        {
          text: "Nombre",
          value: "nombre",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "descripcion",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Color",
          value: "color",
          class: "primary secondary--text",
          align: "center",
          visible: true,
          sortable: false,
          width: "100px",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      openDelete: false,
      itemToDelete: null,
      titleDelete: "la etiqueta?",
      alert: false,
      textAlert: "",
      color: "",
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.$store.dispatch("tags/getOneEmpTags");
  },
  computed: {
    getEmployedTags() {
      return this.$store.state.tags.tagsEmp.etiquetas;
    },
    allHeaders() {
      return configTable.state.colums;
    },
  },
  methods: {
    cancelDelete() {
      this.openDelete = false;
      this.$store.commit("employees/setOpenDelete", false);
    },
    async refreshItems() {
      await this.$store.dispatch("tags/getOneEmpTags");
    },
    openDialog(type, item) {
      this.open = true;
      switch (type) {
        case "delete":
          this.openDelete = true;
          this.itemToDelete = item.etiquetaId;
          break;
        default:
          break;
      }
    },
    deleteItem() {
      this.$store
        .dispatch("tags/deleteEmpTag", this.itemToDelete)
        .then(() => {
          this.showAlert("Se elimino correctamente la etiqueta", "primary");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
      this.openDelete = false;
    },
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {});
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
